import EFPicture from 'elem/compCommon/EFPicture';
import { Collapse } from 'antd';
import { useMemo } from 'react';
import People from 'elem/SVGIcon/PowerBackup/People';
import Store from 'elem/SVGIcon/PowerBackup/Store';
import XStream from 'elem/SVGIcon/PowerBackup/XStream';
import XBoost from 'elem/SVGIcon/PowerBackup/XBoost';
import LFP from 'elem/SVGIcon/PowerBackup/LFP';
import BMS from 'elem/SVGIcon/PowerBackup/BMS';
import Chat from 'elem/SVGIcon/PowerBackup/Chat';
import APR from 'elem/SVGIcon/PowerBackup/APR';
import Warranty from 'elem/SVGIcon/PowerBackup/Warranty';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('offgrid');
    const [active, setActive] = useState(0);
    const lists: any = [
        {
            title: t('secF_list1_title'),
            desc: t('secF_list1_desc'),
            icons: [
                {
                    icon: <People />,
                    text: t('secF_list1_icon1'),
                },
                {
                    icon: <Store />,
                    text: t('secF_list1_icon2'),
                },
            ],
        },
        {
            title: t('secF_list2_title'),
            desc: t('secF_list2_desc'),
            icons: [
                {
                    icon: <XStream className="original" />,
                    text: t('secF_list2_icon1'),
                },
                {
                    icon: <XBoost className="original" />,
                    text: t('secF_list2_icon2'),
                },
                {
                    icon: <LFP className="original" />,
                    text: t('secF_list2_icon3'),
                },
                {
                    icon: <BMS className="original" />,
                    text: t('secF_list2_icon4'),
                },
            ],
        },
        {
            title: t('secF_list3_title'),
            desc: t('secF_list3_desc'),
            icons: [
                {
                    icon: <Chat />,
                    text: t('secF_list3_icon1'),
                },
                {
                    icon: <APR className="original" />,
                    text: t('secF_list3_icon2'),
                },
                {
                    icon: <Warranty />,
                    text: t('secF_list3_icon3'),
                },
            ],
        },
    ];

    const renderImg = useMemo(() => <EFPicture src={`/responsive/picture/off-grid/6_${Number(active || 0) + 1}.jpg`} alt={t('secF_title')} />, [active]);

    return (
        <div id="off-grid-F" className={`off-grid-F off-grid-box ${css['off-grid-F']}`}>
            <div className="text-info">
                <h2 className="title">{t('secF_title')}</h2>
            </div>
            <div className="box-container">
                <div className="img-box top">{renderImg}</div>
                <div className="card-box">
                    <div className="card-inner">
                        <Collapse
                            ghost={true}
                            className="collapse-lists"
                            defaultActiveKey={0}
                            onChange={setActive}
                            accordion={true}
                            expandIcon={({ isActive }: any) => {
                                return (
                                    !isActive && (
                                        <svg
                                            className="collapse-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="25"
                                            viewBox="0 0 25 25"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.5 22.5C18.0228 22.5 22.5 18.0228 22.5 12.5C22.5 6.97715 18.0228 2.5 12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0228 6.97715 22.5 12.5 22.5Z"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M8.5 11.5L12.5 15.5L16.5 11.5"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )
                                );
                            }}
                            expandIconPosition="right"
                        >
                            {lists?.map((list: any, k: number) => (
                                <Collapse.Panel className="list-title" key={k} header={list.title}>
                                    <p className="list-desc">{list.desc}</p>
                                    <ul className="list-icons">
                                        {list?.icons?.map((icon: any, m: number) => (
                                            <li className="list-icon" key={`${k}_${m}`}>
                                                <div className="icon-box">{icon?.icon}</div>
                                                <p className="icon-text">{icon?.text}</p>
                                            </li>
                                        ))}
                                    </ul>
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    </div>
                </div>
                <div className="img-box right">{renderImg}</div>
            </div>
        </div>
    );
}
